import React, { FunctionComponent } from 'react';
import styled from 'styled-components';
import { Prices } from '../../../store/pricing/PricingActions';
import { Price } from '../../../util/Currency';
import { appOverride } from '../../../util/AppUtils';
import { BodyXS } from '../../styles/Typography';
import { SummaryTableRow } from './SummaryTableRow';

type Props = {
  prices: Prices | undefined;
  finePrint: string | undefined;
  regularPlanPrice: Price | undefined;
  ongoingPlanPrice: Price | undefined;
  planIntervalText: string | undefined;
};

export const CostTableRows: FunctionComponent<Props> = ({
  prices,
  finePrint,
  regularPlanPrice,
  ongoingPlanPrice,
  planIntervalText,
}) => {
  const { initialWeeklyPlanPrice, strikethroughWeeklyPrice } = prices || {};

  const controlPrice =
    initialWeeklyPlanPrice !== undefined ? `${initialWeeklyPlanPrice}/week` : undefined;

  const hasDiscountedBilling =
    regularPlanPrice !== undefined &&
    ongoingPlanPrice !== undefined &&
    regularPlanPrice.value !== ongoingPlanPrice.value;

  return (
    <>
      <SummaryTableRow
        dataTest="introPrice"
        description="Price after trial"
        strikethroughPrice={strikethroughWeeklyPrice?.toString()}
        price={controlPrice}
      />
      {hasDiscountedBilling ? (
        <FinePrintRow data-test="finePrint">
          Billed at <Strikethrough>{regularPlanPrice.toString()}</Strikethrough>{' '}
          {ongoingPlanPrice.toString()} every {planIntervalText}
        </FinePrintRow>
      ) : (
        <SummaryTableRow
          dataTest="finePrint"
          description=""
          price={finePrint}
          smallerFont
          halfOpacity
        />
      )}
    </>
  );
};

const FinePrintRow = styled(BodyXS)`
  font-size: ${({ theme }) => theme.fontSize.xxs};
  opacity: ${appOverride({ nerva: 0.8, default: 0.5 })};
  margin-bottom: 0.5em;
  margin-top: 0.5em;
`;

const Strikethrough = styled.span`
  text-decoration: line-through;
`;
